var RollupMenu={viewActions:"View actions"};var _en = {RollupMenu:RollupMenu};

export { RollupMenu, _en as default };
